<template>
    <v-container fluid>   
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="categoryList"
              :items-per-page="50"
              item-key="id"
              sort-by="id"
              :sort-desc=false
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Product Categories</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Category</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md9>
                              <v-text-field v-model="editedItem.text" label="Text"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm6 md3>
                              <v-switch
                                v-model="editedItem.main"
                                label="Main Product"
                              ></v-switch>
                            </v-flex>      
                            <v-flex xs12 sm6 md12>
                              <v-combobox
                                :items="termsList"
                                label="Select Terms"
                                v-model="editedItem.terms"
                                item-text="termName"
                                multiple
                                chips
                                return-object
                              ></v-combobox>
                            </v-flex>                                                                                                                                                                                             
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
const CATEGORIES_API_URL = 'definitions/productCategories';
export default {
    components:{
      LeftMenu,
      DatePicker
    },
    props: {
      termsList: {}
    },
    data () {
    return {
      dialog: false,
      search: '',
      categoryList: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Category', align: 'left', sortable: true, value: 'text'}, 
        { text: 'Operations', value: 'action', sortable: false },
      ]
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Category' : 'Edit Category'
    },
  },
  created() {    
    this.getCategories();   
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    editItem (item) {
      this.editedIndex = this.categoryList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.categoryList.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.categoryList.splice(index, 1);
        this.deleteCategory(item);
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updateCategory(this.editedItem);
      } else {
        this.addCategory(this.editedItem);         
      }      
    },
    addCategory(item){
      this.$axios.post(this.$apiurl + CATEGORIES_API_URL, {
        text: item.text,
        main: item.main ? 1 : 0,
        terms : item.terms ? Array.from(item.terms,x => x.id) : null,
      })
      .then(response => {        
        if (response.status === 201) {
          this.categoryList.push(this.editedItem);
          this.getCategories();   
          this.close();
          this.$emit('productCategoryChanged');
        } 
      }).catch(error => {        
          console.log(error);
        }); 
    },
    updateCategory(item){
      this.$axios.put(this.$apiurl + CATEGORIES_API_URL, {
        id: item.id,
        text: item.text,
        main: item.main ? 1 : 0,
        terms : item.terms ? Array.from(item.terms,x => x.id) : null,
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.categoryList[this.editedIndex], this.editedItem);
          this.close();
          this.$emit('productCategoryChanged');
        }         
      }).catch(error => {        
          console.log(error);
        }); 
    },
    deleteCategory(item){
      this.$axios.delete(this.$apiurl + CATEGORIES_API_URL+'/'+item.id)
      .then(response => {
        this.$emit('productCategoryChanged');
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getCategories(){     
        this.$axios.get(this.$apiurl + CATEGORIES_API_URL)
            .then(response => {
                this.categoryList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
